import React, { useEffect, useState, useRef } from "react";
import Card from '@mui/material/Card';
import { sProfile } from "../../utils/strings";
import { Paper } from "@material-ui/core";
import "../../styles/devices/mob_UserProfile.css";
import { formatHistoryDate } from '../../api/utils/strings';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { IconButton } from "@material-ui/core";
import { Button, TextField, Select, MenuItem } from '@mui/material';
import { useTranslation } from "react-i18next";
import Checkbox from '@mui/material/Checkbox';


export function DialogInfoTeam(props) {
  const { infoTeam, isAdmin, update_InfoTeam } = props;
  const { t } = useTranslation("global")

  const [ stateEdition, setStateEdition ] = useState(false)
  const [ stateSaveBtn, setStateSaveBtn ] = useState(false)


  // TextFields
  const label_ref = useRef();
  const email_ref = useRef();
  const school_ref = useRef();
  const zip_code_ref = useRef();
  const information_ref = useRef();
  const [ isPublic, setIsPublic] = useState(false);

  useEffect(() => {
    // console.log('UPDATE_INFO_TEAM_PUBLIC: ', infoTeam['isPublic'])
    setIsPublic(infoTeam['isPublic'])
  }, [infoTeam]);

  const handleFocus = (event) => {
  }

  const handleBlur = (event) => {
  }

  const handleChange = (event, fieldName) => {
    const selectedValue = event.target.value;
    setStateSaveBtn(true)
  };

  async function save_send_edition() {
    const updated_data = {}
    updated_data['label'] = label_ref.current.value
    updated_data['email'] = email_ref.current.value
    updated_data['school'] = school_ref.current.value
    updated_data['zip_code'] = zip_code_ref.current.value
    updated_data['information'] = information_ref.current.value
    updated_data['isPublic'] = isPublic

    // console.log('SAVE AND SEND')
    // console.log(updated_data)

    update_InfoTeam(updated_data)
    setStateEdition(false)
  }

  function onClickIsPublic(){
    // console.log("🚀 ~ file: DialogInfoTeam.js:55 ~ onClickCheckbox ~ onClickIsPublic:")
    setIsPublic(!isPublic)
    setStateSaveBtn(true)
  }


  return (
    <>
      <Paper className="sig_Teams_PaperContent" elevation={0}>
        {infoTeam['created'] !== undefined ?
          <Card className="sig_Teams_CardContent" elevation={0}>
            {stateEdition == false ?
            <>
              {isAdmin ?
                <IconButton onClick={() => setStateEdition(true)} className="sig_Teams_Button_Edit">
                  <EditIcon color="primary"/>
                </IconButton>
                : <></>
              }

              <div className='sig_Teams_Info_Root'>
                <div className='sig_ProfileInfo_MainContainer'>
                  <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle"> {t("sTeams.table_field_label")} </div>
                      <div className="sig_SignModal_PaperBody">{ infoTeam['label'] }</div>
                  </div>
                  <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle"> {t("sCreateTeams.contact_mail")} </div>
                      <div className="sig_SignModal_PaperBody">{ infoTeam['email'] }</div>
                  </div>
                  <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle"> {t("sCreateTeams.name_center_association")} </div>
                      <div className="sig_SignModal_PaperBody">{ infoTeam['school'] }</div>
                  </div>
                  <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle"> {t("sCreateTeams.address_center")} </div>
                      <div className="sig_SignModal_PaperBody">{ infoTeam['zip_code'] }</div>
                  </div>
                  <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle"> {t("sCreateTeams.more_info")} </div>
                      <div className="sig_SignModal_PaperBody">{ infoTeam['information'] }</div>
                  </div>
                  <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle"> {t("sCreateTeams.created")} </div>
                      <div className="sig_SignModal_PaperBody">{ formatHistoryDate(infoTeam['created']) }</div>
                  </div>
                  {isPublic=== undefined 
                    ? <></>
                    : <div className='sig_SignModal_PaperLine'>
                        <div className="sig_SignModal_PaperTitle"> {t("sProfile.isPublic")} </div>
                        <Checkbox style={{marginRight: '5px'}} checked={isPublic} disabled={true}/>
                    </div>
                  }
                </div>
              </div>
            </>: <>

              <IconButton onClick={save_send_edition} className="sig_Teams_Button_Edit" disabled={!stateSaveBtn}>
                <SaveIcon color={stateSaveBtn ? 'primary' : 'disabled'} />
              </IconButton>

              <div className='sig_Teams_Info_Root'>
                <div className='sig_ProfileInfo_MainContainer'>
                  <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle"> {t("sTeams.table_field_label")} </div>
                      <TextField 
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={label_ref}
                        defaultValue={infoTeam['label']}
                        className="sig_SignModal_PaperBody"
                        onFocus={(e) => handleFocus(e)}
                        onBlur={(e) => handleBlur(e)}
                        onChange={(e) => handleChange(e, 'name')}
                      />
                  </div>
                  <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle"> {t("sCreateTeams.contact_mail")} </div>
                      <TextField 
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={email_ref}
                        defaultValue={infoTeam['email']}
                        className="sig_SignModal_PaperBody"
                        onFocus={(e) => handleFocus(e)}
                        onBlur={(e) => handleBlur(e)}
                        onChange={(e) => handleChange(e, 'name')}
                      />
                  </div>
                  <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle"> {t("sCreateTeams.name_center_association")} </div>
                      <TextField 
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={school_ref}
                        defaultValue={infoTeam['school']}
                        className="sig_SignModal_PaperBody"
                        onFocus={(e) => handleFocus(e)}
                        onBlur={(e) => handleBlur(e)}
                        onChange={(e) => handleChange(e, 'name')}
                      />
                  </div>
                  <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle"> {t("sCreateTeams.address_center")} </div>
                      <TextField 
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={zip_code_ref}
                        defaultValue={infoTeam['zip_code']}
                        className="sig_SignModal_PaperBody"
                        onFocus={(e) => handleFocus(e)}
                        onBlur={(e) => handleBlur(e)}
                        onChange={(e) => handleChange(e, 'name')}
                      />
                  </div>
                  <div>
                      <div className="sig_SignModal_PaperTitle"> {t("sCreateTeams.more_info")} </div>
                      <TextField 
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={information_ref}
                        defaultValue={infoTeam['information']}
                        multiline
                        maxRows={4}
                        className="sig_SignModal_PaperBody"
                        onFocus={(e) => handleFocus(e)}
                        onBlur={(e) => handleBlur(e)}
                        onChange={(e) => handleChange(e, 'name')}
                      />
                  </div>

                  <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle"> {t("sProfile.isPublic")} </div>
                      <Checkbox style={{marginRight: '5px'}} checked={isPublic} onClick={() => onClickIsPublic()}/>
                  </div>

                </div>
              </div>
            
            </>
            }
          </Card>
        : <></>
        }
      </Paper>
    </>
);
}